<template>
    <modal :modal-name="'zoomModal'" :modal-class-name="'zoom-modal'" @close="store.commit('OPEN_MODAL', '')" class="main-modal">
        <template #body>
            <div class="modal-header">
                <div class="close-btn-box">
                    <button @click.prevent="store.commit('OPEN_MODAL', '')" class="close-modal">
                        <close-modal/>
                    </button>
                </div>
            </div>
            <div class="modal-content scroll-box" @click.stop>
                <div class="apartment-img-box">
                    <img :src="store.getters.openModal?.selectedImage" alt="apartment-plan" class="apartment-plan-img">
                </div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import {ref} from "vue";
import { useStore } from 'vuex'

const store = ref(useStore())

</script>

